<lib-habilitation
  libelle="Immobilier"
  [codeConsultant]="consultant().code"
  [habilitation]="consultant().habilitations?.immobilier"
  [demandeHabilitation]="currentDemandes().immobilier"
  [isBo]="isBo()"
  [canInitiateParcours]="canInitiate().immobilier"
  (refreshRequested)="refreshRequested.emit()"
  (initiateParcours)="openInitiation('IMMOBILIER')">
</lib-habilitation>

<lib-habilitation
  libelle="Assurance"
  [codeConsultant]="consultant().code"
  [habilitation]="consultant().habilitations?.assurance"
  [demandeHabilitation]="currentDemandes().assurance"
  [commissionAdi]="consultant().commissionAdiLabel"
  [isBo]="isBo()"
  [canInitiateParcours]="canInitiate().assurance"
  (refreshRequested)="refreshRequested.emit()"
  (initiateParcours)="openInitiation('ASSURANCE')">
</lib-habilitation>

<lib-habilitation
  libelle="IOB"
  [codeConsultant]="consultant().code"
  [habilitation]="consultant().habilitations?.iob"
  [demandeHabilitation]="currentDemandes().financement"
  [isBo]="isBo()"
  [canInitiateParcours]="canInitiate().financement"
  (refreshRequested)="refreshRequested.emit()"
  (initiateParcours)="openInitiation('FINANCEMENT')">
</lib-habilitation>

<lib-habilitation
  libelle="Financement"
  [codeConsultant]="consultant().code"
  [habilitation]="consultant().habilitations?.financement"
  [demandeHabilitation]="currentDemandes().financement"
  [isBo]="isBo()"
  (refreshRequested)="refreshRequested.emit()">
</lib-habilitation>

<lib-habilitation
  libelle="CIF"
  [codeConsultant]="consultant().code"
  [habilitation]="consultant().habilitations?.cif"
  [demandeHabilitation]="currentDemandes().cif"
  [isBo]="isBo()"
  (refreshRequested)="refreshRequested.emit()">
</lib-habilitation>

<lib-habilitation
  libelle="ALPSI"
  [codeConsultant]="consultant().code"
  [habilitation]="consultant().habilitations?.alpsi"
  [demandeHabilitation]="currentDemandes().alpsi"
  [isBo]="isBo()"
  (refreshRequested)="refreshRequested.emit()">
</lib-habilitation>
